import { Button } from '@art-of-hospitality-solutions-llc/ui-kit/components/button';
import { ChevronLeft, ChevronRight } from 'lucide-react';

interface CalendarNavigationProps {
  currentDateLabel: string;
  onNavigate: (direction: 'prev' | 'next' | 'today') => void;
}

export function CalendarNavigation({
  currentDateLabel,
  onNavigate,
}: CalendarNavigationProps) {
  return (
    <div className="flex items-center gap-2">
      <Button variant="outline" size="sm" onClick={() => onNavigate('today')}>
        Today
      </Button>
      <Button
        variant="outline"
        size="sm"
        icon={{ src: <ChevronLeft size={16} /> }}
        onClick={() => onNavigate('prev')}
        aria-label="Previous"
      />
      <Button
        variant="outline"
        size="sm"
        icon={{ src: <ChevronRight size={16} /> }}
        onClick={() => onNavigate('next')}
        aria-label="Next"
      />
      <div className="ml-2 font-medium">{currentDateLabel}</div>
    </div>
  );
}
